import * as React from "react";
const SvgFiRrHouseTsunami = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-tsunami_svg__a)">
      <path
        fill="#062147"
        d="M23.744 21.565a1 1 0 0 1-.075 1.412 4 4 0 0 1-2.668 1.022 4.38 4.38 0 0 1-3-1.225 4.38 4.38 0 0 1-3 1.225 4.38 4.38 0 0 1-3-1.225 4.38 4.38 0 0 1-3 1.225 4.38 4.38 0 0 1-3-1.225 4.38 4.38 0 0 1-3 1.225 3.99 3.99 0 0 1-2.668-1.022 1 1 0 0 1 1.337-1.488A2 2 0 0 0 3.002 22c.89 0 1.793-.586 2.057-1.333a1 1 0 0 1 1.886 0C7.209 21.414 8.112 22 9.002 22s1.793-.586 2.057-1.333a1 1 0 0 1 1.886 0c.264.747 1.167 1.333 2.057 1.333s1.793-.586 2.057-1.333a1 1 0 0 1 1.886 0c.264.747 1.167 1.333 2.057 1.333.493 0 .965-.182 1.332-.511a1 1 0 0 1 1.412.076zm-1.333-17.84L20.054 1.88a4.13 4.13 0 0 0-5.106 0l-2.357 1.845a4.12 4.12 0 0 0-1.59 3.262V12a1 1 0 1 0 2 0V6.987c0-.663.3-1.278.822-1.688l2.357-1.845a2.144 2.144 0 0 1 2.642 0l2.357 1.845c.522.409.822 1.024.822 1.688V12a1 1 0 1 0 2 0V6.987c0-1.282-.58-2.472-1.59-3.262m-4.41 6.274a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1zm4.332 5.489a2 2 0 0 1-1.332.511c-.89 0-1.793-.586-2.057-1.333a1 1 0 0 0-1.886 0c-.229.647-1.543 1.333-2.557 1.333h-.5c-4.187 0-7-2.813-7-7 0-2.812 1.618-5.75 3.934-7.144a1 1 0 0 0-.515-1.856h-.918C4.084 0 0 3.869 0 9v4a1 1 0 1 0 2 0V9c0-3.338 2.255-5.989 5.495-6.768C5.943 4.099 5 6.555 5 9c0 5.299 3.701 9 9 9h.5c1.136 0 2.497-.484 3.439-1.285A4.38 4.38 0 0 0 21 18c.987 0 1.935-.363 2.668-1.022a1 1 0 0 0-1.337-1.488z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-tsunami_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseTsunami;
